import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import {
	AppNotfoundComponent,
	AppErrorComponent
} from "esz-saas-lcp-ng-crud-ui";

import { WsMainComponent } from './view/ws-main/ws-main.component';
import { WsHomepageComponent } from "./view/ws/pages/ws-homepage/ws-homepage.component";
import { WsAboutusComponent } from "./view/ws/pages/ws-aboutus/ws-aboutus.component";
import { WsContactComponent } from "./view/ws/pages/ws-contact/ws-contact.component";
import { WsServicesComponent } from "./view/ws/pages/ws-services/ws-services.component";
import { WsFreeSoftwareComponent } from "./view/ws/pages/ws-free-software/ws-free-software.component";
import { WsSnapcartComponent } from "./view/ws/pages/ws-snapcart/ws-snapcart.component";
import { WsPrivacyComponent } from "./view/ws/pages/ws-privacy/ws-privacy.component";
import { WsTermsComponent } from "./view/ws/pages/ws-terms/ws-terms.component";

const routes: Routes = [
	{
		path: '',
		component: WsMainComponent,
		children: [
			{ path: '', component: WsHomepageComponent, pathMatch: 'full' },
			{ path: 'aboutus', component: WsAboutusComponent, pathMatch: 'full' },
			{ path: 'contact', component: WsContactComponent, pathMatch: 'full' },
			{ path: 'services', component: WsServicesComponent, pathMatch: 'full' },
			{ path: 'free-software', component: WsFreeSoftwareComponent, pathMatch: 'full' },
			{ path: 'snapcart', component: WsSnapcartComponent, pathMatch: 'full' },
			{ path: 'privacy', component: WsPrivacyComponent, pathMatch: 'full' },
			{ path: 'terms', component: WsTermsComponent, pathMatch: 'full' }
		]
	},

	// No sign-in routes (/sso, /sign-in, /access, /default): eszes.in has no member sign-in, only
	// anonymous forms. They fall through to '**' like any unknown path. See no-sign-in.spec.ts.
	{ path: 'notfound', component: AppNotfoundComponent },
	{ path: 'error', component: AppErrorComponent },
	{ path: '**', redirectTo: '/notfound' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			// Path URLs (/aboutus) since 2026-09-17: crawlers treat /#/aboutus as the home page.
			// CloudFront maps 403/404 to /index.html with a 200, so deep links resolve; main.ts
			// rewrites legacy #/ links before bootstrap.
			useHash: false,
			// Render nothing until the first route has resolved: with the default non-blocking
			// navigation the shell (topbar + empty outlet + footer) painted first on slow devices and
			// the footer was then pushed a full viewport down (PageSpeed CLS 0.9, 2026-09-17).
			initialNavigation: 'enabledBlocking',
			scrollPositionRestoration: "enabled",
			anchorScrolling: "enabled",          // /services#commerce and /snapcart#setup scroll on load
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule { }
